import React from 'react';
import { Link } from 'gatsby';
import { ThemeProvider } from 'styled-components';
import OImage from '../OImage';
import Wysiwyg from '../Wysiwyg';

import Wrapper from '../../ui/Wrappers';
import { themes } from '../../ui/design-tokens';
import { Module, Container, ContentZone, ImageZone, TextZone } from './styles';
import { ButtonSmall } from '../../ui/Button';
import { getSrcset, externalLink } from '../../ui/helpers';

interface IProps {
  theme?: string;
  heading?: string;
  title?: string;
  subtitle?: string;
  direction: string;
  text: string;
  link?: { uri: string; title: string };
  imageUrl: any;
  imageAlt?: string;
  position?: string;
  centeredContent?: boolean;
  fullwidth?: boolean;
  elementId?: string;
}

const ImageText = ({
  theme,
  heading,
  subtitle,
  title,
  direction,
  text,
  link,
  imageUrl,
  imageAlt,
  position,
  centeredContent,
  fullwidth,
  elementId
}: IProps) => {
  const cleanedTheme = theme ? theme : 'white';
  const isGradient = cleanedTheme.endsWith('_gradient') || cleanedTheme === 'neutral_black';
  return (
    <ThemeProvider theme={themes[isGradient ? 'gradients' : 'billboard'][cleanedTheme]}>
      <Module centeredContent={centeredContent} gradient={isGradient} id={elementId}>
        <Wrapper
          fullwidth={fullwidth}
          size="reader"
          as={Container}
          className={`${direction === 'text_right' ? 'reverse' : ''}`}>
          <Wrapper fullwidth={fullwidth} as={ContentZone} className={`${direction === 'text_right' ? 'reverse' : ''}`}>
            <TextZone gradient={isGradient}>
              {(subtitle && position === 'pretitle') || !position ? (
                <p className="subtitle">{subtitle}</p>
              ) : (
                ''
              )}
              {title &&
                (heading === 'heading_2' ? (
                  <h2 className="title">{title}</h2>
                ) : (
                  <h3 className="title">{title}</h3>
                ))}
              {subtitle && position === 'subtitle' ? <p className="subtitle">{subtitle}</p> : ''}
              <Wysiwyg
                className="text"
                text={text}
              />

              {link && link?.uri && (
                <div className={'ctaContainer'}>
                  <ButtonSmall
                    as={externalLink(link.uri) ? 'a' : Link}
                    className="btn"
                    href={externalLink(link.uri) ? link.uri : null}
                    to={externalLink(link.uri) ? null : link.uri}
                    target={externalLink(link.uri) && '_blank'}
                    rel={externalLink(link.uri) && 'nofollow noopener noreferrer'}
                    secondary={1}
                    data-gtm-action={`image-text_${
                      title ? title : text.length >= 10 ? text.substring(0, 10) : 'untitled'
                    }`}
                    data-gtm-category="cta"
                    data-gtm-event
                    data-gtm-label={`${
                      title ? title : text.length >= 10 ? text.substring(0, 10) : 'untitled'
                    }_${typeof window !== 'undefined' ? window.location.href : ''}`}>
                    {link.title}
                  </ButtonSmall>
                </div>
              )}
            </TextZone>
            <ImageZone>
              {imageUrl && (
                <OImage
                  src={imageUrl.original?.href}
                  aspectRatio={imageUrl.original?.meta.width / imageUrl.original?.meta.height}
                  srcSet={getSrcset(imageUrl)}
                  webp={getSrcset(imageUrl, true)}
                  alt={imageAlt || ''}
                  className="image"
                />
              )}
            </ImageZone>
          </Wrapper>
        </Wrapper>
      </Module>
    </ThemeProvider>
  );
};

export default ImageText;
